//
//
//
//
//
//
//
//
//
//
//
//
//

import { swiper, swiperSlide } from "vue-awesome-swiper"
export default{
  components: { swiper, swiperSlide },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    refName: {
      type: String,
      default: 'globalSwiper'
    }
  },
  data() {
    let vm = this;
    return {
      swiperOptions: {
        slidesPerView: "auto",
        centeredSlides:true,
        spaceBetween: 6,
        loop: true,
        // autoplay: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        // navigaiton: {
        //   prevEL:'.swiper-button-prev',
        //   nextEL:'.swiper-button-next',
        //   hideOnClick: true
        // },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        on: {
          click: () => {
            // this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
            // console.log(this); // -> Swiper
            // 当前活动块的索引，与activeIndex不同的是，在loop模式下不会将 复制的块 的数量计算在内。
            vm.$emit('update', vm.$refs[vm.refName].swiper.realIndex)
          }
        },
      }
    }
  },
  created() {
    let options = Object.assign({}, this.options)
    if (options.autoplay) delete options.autoplay
    if (options.pagination) delete options.pagination
    if (options.navigaiton) delete options.navigaiton
    this.swiperOptions = Object.assign({}, this.swiperOptions, options)
  },
  methods: {
    slideTo(v) { // 左右切换
      if (v === -1) this.$refs[this.refName].swiper.slidePrev()
      if (v === 1) this.$refs[this.refName].swiper.slideNext()
    },
  }
}



// WEBPACK FOOTER //
// ./src/common/components/g-awesome-swiper/index.vue